<template>
  <div class="modal fade" id="behaviorTrackerManageUsersModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Manage Tracker Users</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="Users != null" class="modal-body">
          <form>
            <div class="form-group">
              <label
                ><strong
                  >Manage Users for {{ BehaviorTracker.Title }}</strong
                ></label
              >
            </div>
            <div
              v-for="user in Users.slice().sort($orderByLastName)"
              :key="user.User_Id + 'assign'"
              class="form-group form-check"
            >
              <input
                type="checkbox"
                class="form-check-input"
                v-bind:id="user.User_Id + 'assign'"
                v-bind:value="user.User_Id"
                v-model="selectedUsers"
              />
              <label
                class="form-check-label"
                v-bind:for="user.User_Id + 'assign'"
                >{{ user.First_Name }} {{ user.Last_Name }}</label
              >
            </div>
            <div class="row">
              <div class="col text-left">
                <button
                  type="button"
                  class="btn btn-primary"
                  v-on:click="cancel"
                >
                  cancel
                </button>
              </div>
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-primary"
                  v-on:click="saveUsers"
                >
                  Save Users
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  components: {},
  props: {
    BehaviorTracker: Object,
    Users: Array
  },
  data() {
    return {
      originalUsers: this.BehaviorTracker.Users.map(u => u.User_Id),
      selectedUsers: this.BehaviorTracker.Users.map(u => u.User_Id)
    };
  },
  watch: {
    BehaviorTracker: function() {
      this.originalUsers = this.BehaviorTracker.Users.map(u => u.User_Id);
      this.selectedUsers = this.BehaviorTracker.Users.map(u => u.User_Id);
    }
  },
  methods: {
    cancel() {
      this.selectedUsers = this.BehaviorTracker.Users.map(u => u.User_Id);
      $("#behaviorTrackerManageUsersModal").modal("hide");
    },
    async saveUsers() {
      $("#behaviorTrackerManageUsersModal").modal("hide");
      this.$store.commit("updateLoading", true);
      var newUsers = this.selectedUsers.filter(
        u => !this.originalUsers.includes(u)
      );
      var removedUsers = this.originalUsers.filter(
        u => !this.selectedUsers.includes(u)
      );
      await this.$createBehaviorTrackerUsersAssignments(
        this.BehaviorTracker.Behavior_Tracker_Id,
        newUsers
      );
      newUsers.forEach(userId => {
        this.BehaviorTracker.Users.push(
          this.Users.find(u => u.User_Id == userId)
        );
      });
      await this.$removeBehaviorTrackerUsersAssignments(
        this.BehaviorTracker.Behavior_Tracker_Id,
        removedUsers
      );
      this.BehaviorTracker.Users = this.BehaviorTracker.Users.filter(
        u => !removedUsers.includes(u.User_Id)
      );
      this.$store.commit("updateLoading", false);
    }
  }
};
</script>
